import axios from 'axios';

export const Api_Url = "https://professional-house-backend.vercel.app";
// export const Api_Url = "http://localhost:8080";

const api = axios.create({
    baseURL: Api_Url,
});

api.interceptors.request.use(
    async config => {
        try {
            const token = localStorage.getItem("userToken");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            console.error('Failed to retrieve token:', error);
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

export default api;
